import { IGetAllTreinamentoFuncionarioUseCase } from "../../../presentation/useCases/read/get_all_treinamento_funcionario_use_case";
import { TreinamentoFuncionario } from "../../models/treinamento_funcionario";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * GetAllTreinamentoFuncionarioUseCase
 */

export class GetAllTreinamentoFuncionarioUseCase implements IGetAllTreinamentoFuncionarioUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async getAllTreinamentoFuncionario(
    cargos: number[],
    centroCustos: number[],
  ): Promise<TreinamentoFuncionario[]> {
    return await this.repository.getAllTreinamentoFuncionario(
      cargos,
      centroCustos,
    );
  }
}
